import axios from 'axios'     //引入
import { Dialog } from 'vant';
import router from './../router'

// 部分内嵌 WebView 中 sessionStorage 无 setItem，统一用安全读写（优先 localStorage）
function storageOk (s) {
  return s && typeof s.setItem === 'function' && typeof s.getItem === 'function'
}
function getLS (key) {
  try {
    if (storageOk(typeof localStorage !== 'undefined' ? localStorage : null)) return localStorage.getItem(key) || ''
  } catch (e) {}
  return ''
}
function setLS (key, val) {
  try {
    if (storageOk(typeof localStorage !== 'undefined' ? localStorage : null)) localStorage.setItem(key, val)
  } catch (e) {}
}
function getSS (key) {
  try {
    if (storageOk(typeof sessionStorage !== 'undefined' ? sessionStorage : null)) return sessionStorage.getItem(key) || ''
  } catch (e) {}
  return ''
}
function removeSS (key) {
  try {
    if (storageOk(typeof sessionStorage !== 'undefined' ? sessionStorage : null)) sessionStorage.removeItem(key)
  } catch (e) {}
}
function clearStorageSafe (s) {
  try {
    if (storageOk(s) && typeof s.clear === 'function') s.clear()
  } catch (e) {}
}

// 生产域名优先读 static/js/config.js（打包后可直接改，无需重编）
const DEFAULT_BASE_URL = 'https://admin.xzb8888.com'
let baseURL = (typeof window !== 'undefined'
  && window.__APP_CONFIG__
  && window.__APP_CONFIG__.baseURL)
  || DEFAULT_BASE_URL
setLS('baseURL', baseURL)

// 旧版 token 在 sessionStorage，迁到 localStorage 以便长期保持登录
;(function migrateToken () {
  const t = getSS('token')
  if (t && !getLS('token')) {
    setLS('token', t)
    removeSS('token')
  }
})()

//这一步的目的是判断出当前是开发环境还是生成环境，方法不止一种，达到目的就行
if(process.env.NODE_ENV=="development"){
  baseURL=''
}
setLS('baseURL', baseURL)

let config = {
    baseURL: baseURL,
    timeout: 30000       //设置最大请求时间
}
const _axios = axios.create(config)

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    config => {
        //如果有需要在这里开启请求时的loading动画效果
        // Authorization:Bearer hPxf6a8TQnCkExTYxceujYgXoW9GXB9909zsZtpvabw6yO9ngcMVKgLx4mzD
        let token = getLS('token')
        config.headers.Authorization = 'Bearer ' + token;  //添加token,需要结合自己的实际情况添加，
        return config;
    },
    err => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
    res => {
        //在这里关闭请求时的loading动画效果
        //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写

        if (res.data.code === 401) {
            Dialog.alert({
                title: '认证失败',
                message: '您的账号登陆过期，请重新登陆',
              }).then(() => {
                clearStorageSafe(typeof localStorage !== 'undefined' ? localStorage : null);
                clearStorageSafe(typeof sessionStorage !== 'undefined' ? sessionStorage : null);
                router.replace('/login');
              });
        }
        return res;
    },
    err => {
        if (err) {
            //在这里关闭请求时的loading动画效果
            // Toast("请求网络失败")
        }
        return Promise.reject(err);
    }
);

//封装post,get方法
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            // 'Content-Type': 'application/json'
            _axios({
                url,
                params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}) {
        if (url == '/api/register' || url == '/api/login' || url == '/api/login_pc') {
            setLS('baseURL', baseURL)
        }
        return new Promise((resolve, reject) => {
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'POST'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}


/** 给 api.js、页面组件读取已持久化的 API 根地址，避免直接访问不安全的 sessionStorage */
export function getPersistedBaseUrl () {
  return getLS('baseURL')
}

/** 安全清空本地存储（内嵌环境 sessionStorage 可能无 clear） */
export function clearAllWebStorage () {
  clearStorageSafe(typeof localStorage !== 'undefined' ? localStorage : null)
  clearStorageSafe(typeof sessionStorage !== 'undefined' ? sessionStorage : null)
}

export default http



// WEBPACK FOOTER //
// ./src/http/http.js